import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchLatestWorkspaceExport } from '@/api/workspaceExport/workspaceExportApi';
import type { WorkspaceExport } from '@/api/workspaceExport/workspaceExportApi.types';
import { WORKSPACE_EXPORT_QUERY_KEY } from '@/constants/queryKeys';
import { resolveWorkspaceExportPollingInterval } from '@/utils/workspaceExportStatus';

export function useWorkspaceExportQuery(): UseQueryResult<WorkspaceExport | null, Error> {
  return useQuery({
    queryKey: WORKSPACE_EXPORT_QUERY_KEY,
    queryFn: fetchLatestWorkspaceExport,
    refetchInterval: function resolveRefetchInterval(query) {
      return resolveWorkspaceExportPollingInterval(query.state.data);
    },
  });
}
